export default {

  aiGO: {
    createNewTalk: 'create'
  }
}